import React from 'react';
import { FormattedPlural } from 'react-intl';

interface Props {
	value: number;
}
export const FormattedMinutesText: React.FC<Props> = ({ value }) => (
	<FormattedPlural value={value} one="minute" other="minutes" />
);
